import React from 'react';

// @mui
import { TableCell } from '@mui/material';

export default class GridNumberCell extends React.Component {
    render() {
        const baseStyle = this.props.styles;
        const { field, value } = this.props;
        // A field whose null means "not set" (blankWhenNull) shows an empty cell
        // rather than 0, where 0 is a real value of its own. A prefix goes before
        // a value that is there: '#' for another record's id.
        const blank = field.blankWhenNull && (value === null || value === undefined);
        const shown = blank ? '' : `${field.prefix || ''}${value || 0}`;

        return (
            <TableCell key={field.id} align="right" sx={{ ...baseStyle }}>
                {shown}
            </TableCell>
        );
    }
}
